import React, {Component} from 'react';
import {Line} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getGradients} from './budget_charts_util';

class InvoiceChart extends Component {
	getChartData() {
		const {itemsOutsideProjectPeriod} = this.props;
		const {formatMessage} = this.props.intl;
		const {invoicedPerDay, totalPaymentsPerDay, project, labels} = this.props.data;
		const {invoicedGradientFill, paidGradientFill} = getGradients();

		const paidMoneyPerDay = getAccumulation(getChartDataByDay({project, dayData: totalPaymentsPerDay}));
		const invoicedMoneyPerDay = getAccumulation(getChartDataByDay({project, dayData: invoicedPerDay}));

		return {
			datasets: [
				{
					label: formatMessage({id: 'settings_subscription.paid'}),
					borderColor: 'rgb(255, 206, 239)',
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointBackgroundColor: 'rgb(255, 206, 239)',
					pointHoverBorderColor: '#fff',
					pointRadius: 0,
					fill: true,
					backgroundColor: paidGradientFill,
					borderWidth: 2,
					data: paidMoneyPerDay,
				},
				{
					label: formatMessage({id: 'common.invoiced'}),
					borderColor: 'rgba(246, 218, 26, 0.5)',
					pointBackgroundColor: 'rgba(246, 218, 26, 0.5)',
					pointHoverBorderColor: '#fff',
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointRadius: 0,
					fill: true,
					backgroundColor: invoicedGradientFill,
					borderWidth: 2,
					data: invoicedMoneyPerDay,
				},
			].concat(itemsOutsideProjectPeriod ? itemsOutsideProjectPeriod : []),
			labels,
		};
	}

	render() {
		return <Line data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(InvoiceChart);
